import { FormControl, FormLabel, Select } from '@chakra-ui/react'
import useConfigList from '../../../../hooks/useConfigList'

export const DeceasedReasonsSelect = ({
  value,
  onChange,
  isDisabled = false,
}: {
  value: string
  onChange: (value: string) => void
  isDisabled?: boolean
}) => {
  const deceasedReasons = useConfigList('deceasedReasons') as Record<
    string,
    string
  >

  return (
    <FormControl>
      <FormLabel>Cause of Death</FormLabel>
      <Select
        placeholder='Select cause'
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        isDisabled={!!isDisabled}
      >
        {Object.entries(deceasedReasons || {})
          .sort((a, b) => a[1].localeCompare(b[1]))
          .map(([id, name]) => (
            <option key={id} value={id}>
              {String(name)}
            </option>
          ))}
      </Select>
    </FormControl>
  )
}
